"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContainerMovement = getContainerMovement;
exports.getNacList = getNacList;
exports.getVipCargoContainer = getVipCargoContainer;
exports.vipCargoTrack = vipCargoTrack;
var _request = _interopRequireDefault(require("@/utils/request"));
/**
 * 日本VIP客户-货物跟踪查询
 * 订舱查询
 * @param query
 */
function vipCargoTrack(query) {
  return (0, _request.default)({
    url: '/equery/cargoTrack/cargoTrackSearch',
    method: 'get',
    params: query
  });
}

/**
 *日本VIP客户-箱信息
 * @param id
 */
function getVipCargoContainer(id) {
  return (0, _request.default)({
    url: '/equery/cargoTrack/' + id,
    method: 'get'
  });
}

/**
 *日本VIP客户-箱动态信息
 * @param id
 */
function getContainerMovement(query) {
  return (0, _request.default)({
    url: '/equery/cargoTrack/containerMovement',
    method: 'post',
    params: query
  });
}

/**
 *获取NAC List
 * @param id
 */
function getNacList() {
  return (0, _request.default)({
    url: '/equery/cargoTrack/selectNacByFreightName',
    method: 'get'
  });
}